import { CloseOutlined } from "@ant-design/icons"
import { Flex, Space, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import CheckMarkblue from "../../../../../Icon/img/checkMarkblue"
import { alertsColumnIconMap, dateFormat } from "../../../../../Utils/utils"

dayjs.extend(utc)

const { Text } = Typography

export const defaultColumns = [
  { field_id: "event_name", label: "Event name", active: true },
  { field_id: "source_id", label: "Source ID", active: true },
  { field_id: "created_timestamp", label: "Date", active: true }
]

export const getColumns = ({ theme }) => ({
  event_name: {
    // key: 'event_name',
    // sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Event name",
        sorter: true,
        stateData: state,
        key: "event_type"
      }),
    dataIndex: "event_type",
    fixed: "left",
    // width: 120,
    render: (value, record) => {
      return (
        <Flex gap={8} align="center">
          <div>
            {record?.is_successful ? (
              <CheckMarkblue color={"#35BD29"} />
            ) : (
              <CloseOutlined style={{ color: "#D71313" }} />
            )}
          </div>
          <div>{value}</div>
        </Flex>
      )
    }
  },
  source_id: {
    // key: 'source_id',
    // sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Source ID",
        sorter: true,
        stateData: state,
        key: "source_id"
      }),
    dataIndex: "source_id",
    // width: 128,
    render: (value, record) => <Text>{value}</Text>
  },
  created_timestamp: {
    // key: 'created_timestamp',
    // sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Date",
        sorter: true,
        stateData: state,
        key: "sent_at"
      }),
    dataIndex: "last_event_at",
    // width: 140,
    render: (value, record) => (
      <Space size={4}>
        <Text>{dayjs(value).format(dateFormat)}</Text>
        <Text type="secondary">{dayjs(value).format("h:mm A [(UTC)]")}</Text>
      </Space>
    )
  }
})

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      sorter: true,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id,
  width: 185,
  ellipsis: true,
  render: (_) => _ || "—"
})

// export const getActionColumn = ({onSelectRow}) => {

//   const handleAction = (e, data, type) => {
//     e.preventDefault()
//     e.stopPropagation()
//     onSelectRow(data, type)
//   }
//   return {
//     key: 'actions',
//     title: '',
//     width: 70,
//     render: (_, record) => (
//       <Flex>
//         <Tooltip title="Add event">
//           <ButtonComponent
//             type="link"
//             icon={<Icon type={'plus'} />}
//             onClick={e => handleAction(e, record, 'add_event')}
//             className="flex center "
//           />
//         </Tooltip>
//       </Flex>
//     ),
//   }
// }
